import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import 'swiper/css';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useNavigate } from 'react-router-dom';
import { getAssetsBaseUrl } from '../../../../config/assetsUrl';
import SwipeDownIcon from '../../../common/SwipeDownIcon';
import LeftSection from './LeftSection';
import './styles.css';

const images = [
    `${getAssetsBaseUrl()}/images/gallery/WhatsApp Image 2026-02-02 at 21.14.36 (2).jpeg`,
    `${getAssetsBaseUrl()}/images/gallery/WhatsApp Image 2026-02-02 at 21.16.56.jpeg`,
    `${getAssetsBaseUrl()}/images/gallery/WhatsApp Image 2026-02-02 at 21.14.37.jpeg`,
    `${getAssetsBaseUrl()}/images/gallery/WhatsApp Image 2026-02-02 at 21.16.46 (2).jpeg`,
];

interface LandingProps {
}

const Landing: React.FC<LandingProps> = ({ }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    return (
        <Box
            sx={(theme) => ({
                mt: { xs: 8, sm: 12 },
                position: "relative",
                backgroundImage: `url(${getAssetsBaseUrl()}/images/background/landingimage4.jpeg)`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                zIndex: 3,
                "&::before": {
                    // background: "#575757",
                    background: "#a4a4a444",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                    content: '""',
                    // opacity: .4,
                    opacity: .5,
                    ...theme.applyStyles("dark", {
                        background: "#2e2e2eff",
                        opacity: .5,
                    })
                },
            })}
            // mb={4}
            pl={0}
            pr={0}
            pb={{ xs: 0, sm: 8 }}
            width={"100vw"}
            marginLeft={"calc(50% - 50vw)"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}>
            <Box
                sx={(theme) => ({
                    marginTop: { xs: "0px", sm: "80px" },
                    width: "100%",
                    maxWidth: 1160,
                    px: { xs: 2, md: 8 },
                    py: { xs: 4, md: 10 },
                    backgroundColor: "#0e102980",
                    backdropFilter: "blur(16px)",
                    borderRadius: { xs: 0, sm: 2 },
                    border: isMobile ? "none" : "2px solid #ffffff4f",
                    // maxWidth: 1200,
                    zIndex: 10,
                    ...theme.applyStyles("dark", {
                        // backgroundColor: '#4444444c',

                    })
                })}
            >
                <Box
                    display={"flex"}
                    flexDirection={isMobile ? "column" : "row"}
                    gap={{ xs: 4, md: 14 }} >
                    <LeftSection />

                    <Swiper
                        spaceBetween={0}
                        className="home-swiper"
                        effect={'fade'}
                        navigation={true}
                        loop
                        autoplay
                        pagination={{
                            clickable: true,
                        }}
                        modules={[EffectFade, Autoplay, Pagination]}
                    >
                        {images.map((src, index) => (
                            <SwiperSlide key={`home-slide-${index}`} style={{ borderRadius: "16px", overflow: "hidden" }}>
                                <Box
                                    component="img"
                                    src={src}
                                    alt={`Enduro ${index + 1}`}
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        display: 'block',
                                    }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Box>
            </Box>
            <SwipeDownIcon />
        </Box>

    );
}

export default Landing;